import events from '../../../../../events.js'

const {SIGNED_IN, SIGNED_UP} = events

const AUTHENTICATION_EVENTS_VERSIONS = {
  [SIGNED_IN]: 2,
  [SIGNED_UP]: 2
}

const GOT_HIT_ORIGIN = ['google one tap', 'pta']

const getVersionFromPayloadInAuthenticationEvents = ({event, payload}) => {
  const {obj: {properties: {hit_origin: hitOrigin} = {}} = {}} = payload

  const hasAuthenticationEventVersion = GOT_HIT_ORIGIN.includes(hitOrigin)

  return hasAuthenticationEventVersion ? AUTHENTICATION_EVENTS_VERSIONS[event] : null
}

const authenticationEventVersionsMapper = ({event, payload}) => {
  return Object.keys(AUTHENTICATION_EVENTS_VERSIONS).includes(event)
    ? getVersionFromPayloadInAuthenticationEvents({event, payload})
    : null
}

export default authenticationEventVersionsMapper
